import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AppointmentTypeService } from 'src/app/services/core/appointment-type/appointment-type.service';
import { sweetAlert } from 'src/app/utils/swal';
@UntilDestroy()

@Component({
  selector: 'app-appointmenttype',
  templateUrl: './appointmenttype.component.html',
  styleUrls: ['./appointmenttype.component.css']
})
export class AppointmenttypeComponent implements OnInit {

  appointmentForm!: FormGroup;
  appointmentId :any;
  submitted = false;

  // Edit Modal Inputs and Outputs
  @Input() appointmentType: any;
  @Input() source: any;
  @Output() onSaveAppointmentType = new EventEmitter<string>();
  @Output() onCloseModal = new EventEmitter<string>();
  // Edit Modal Inputs and Outputs End

  constructor(private fb: FormBuilder, private route: ActivatedRoute, private router: Router,private appointmentTypeService: AppointmentTypeService){

  }

  ngOnInit(){
    if (this.source === 'modal' && this.appointmentType) {
      this.appointmentId = this.appointmentType.id;
      this.getAppointmentById();
    } else {
      this.appointmentId = this.route.snapshot.params['appointmentTypeId'];
      if (this.appointmentId) {
         this.getAppointmentById();
      }
    }


    this.appointmentForm = this.fb.group({
      title: ['', Validators.required],
      isActive: [true, Validators.required],
      description: ['', Validators.required],
    })
  }

  get form(){
    return this.appointmentForm.controls;
  }

  onSave(){
    this.submitted = true;
    if(this.appointmentForm.invalid)
      return;

    const payload = this.appointmentForm.value;

    this.appointmentTypeService.saveAppointment(this.appointmentId, payload).pipe(untilDestroyed(this)).subscribe((data: any) =>{
      if(data){
        if (this.source === 'modal') {
          this.onSaveAppointmentType.emit(data);
        } else {
          this.router.navigateByUrl('/configurations/appointmenttype');
        }
      }
    },
      (err) => {
        sweetAlert("Error", err, "error", "OK");
      }
  )
  }

  getAppointmentById(){
    this.appointmentTypeService.getAppointmentById(this.appointmentId).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.appointmentForm.patchValue({
          ...data
        });
      }
    })
  }
}
